import { render, staticRenderFns } from "./tax-report.vue?vue&type=template&id=a944a9e0&"
import script from "./tax-report.vue?vue&type=script&lang=js&"
export * from "./tax-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports